import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID,
    ViewChild,
} from "@angular/core";
import { VenueService } from "../venue.service";
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { MlpHelper } from "../../shared/mlpHelper";
import { IGoogleMapsStatic } from "../../shared/component/google-maps-static/google-maps-static.interface";

@Component({
    selector: "mlp-tabs",
    templateUrl: "tabs.component.html",
    styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent implements OnInit {
    @ViewChild("venueTabSet") public tabSet: NgbTabset;
    @Input() openMapEvent = new EventEmitter();

    public showMore: boolean = false;
    public showMoreLimit: number;

    // Gmaps settigns
    public lat: number;
    public lng: number;
    public zoom: number = 15; //Streets. Add +5 for Buildings
    public isBrowser: boolean = isPlatformBrowser(this.platformId);

    showDynamicMap = false;
    staticMapConfig: IGoogleMapsStatic;
    isMapLoading = false;
    isUnableToLoadMap = false;
    showPointerIcon = true;
    mapMessages = {
        unableToLoadMap: "Unable to load interactive map, please try again",
        staticMapMessage: "Click to interact with the map",
        staticMapMessageMobile: "Tap to interact with the map",
    };
    staticMapMessage: string;
    staticMapMessageMobile: string;

    constructor(
        public venueService: VenueService,
        @Inject(PLATFORM_ID) private platformId,
        @Inject(DOCUMENT) private doc: any
    ) {
        this.venueService.pitchDataChange.subscribe(() => {
            this.reset();
        });

        this.venueService.venueDataChange.subscribe(() => {
            this.resetLatLong();
            if (this.isBrowser) {
                this.generateStaticMapConfig();
            }
        });
    }

    ngOnInit() {
        this.staticMapMessage = this.mapMessages.staticMapMessage;
        this.staticMapMessageMobile = this.mapMessages.staticMapMessageMobile;

        this.openMapEvent.subscribe(() => {
            this.tabSet.select("tab-select-map");
        });

        if (this.venueService.pitchData && this.venueService.venueData) {
            this.reset();
            this.resetLatLong();
        }
    }

    add3dots(text) {
        return MlpHelper.add3Dots(text, this.showMoreLimit);
    }

    showMoreClick() {
        this.showMore = true;
        this.showMoreLimit = 5000;

        return false;
    }

    changeMapsToDynamic(): void {
        this.isMapLoading = true;
        this.showDynamicMap = true;
        setTimeout(() => {
            if (this.isMapLoading) {
                this.isUnableToLoadMap = true;
                setTimeout(() => {
                    this.isUnableToLoadMap = false;
                    this.staticMapMessage = this.mapMessages.unableToLoadMap;
                    this.staticMapMessageMobile =
                        this.mapMessages.unableToLoadMap;
                    this.showPointerIcon = false;
                    this.showDynamicMap = false;
                }, 1000);
            }
        }, 5000);
    }

    hideLoadingIcon(event): void {
        this.isMapLoading = false;
        this.staticMapMessage = this.mapMessages.staticMapMessage;
        this.staticMapMessageMobile = this.mapMessages.staticMapMessageMobile;
        this.showPointerIcon = true;
    }

    private reset() {
        this.showMore = false;
        this.showMoreLimit = 500;

        if (this.tabSet && this.venueService.pitchData.data.attributes.about) {
            this.tabSet.select("tab-select-desc");
        }
    }

    private resetLatLong() {
        this.lat = Number(this.venueService.venueData.data.attributes.latitude);
        this.lng = Number(
            this.venueService.venueData.data.attributes.longitude
        );
    }

    private generateStaticMapConfig(): void {
        const head = this.doc.getElementsByTagName("head")[0];
        const insertBefore = head.insertBefore;
        head.insertBefore = (newElement, referenceElement) => {
            if (
                newElement.href &&
                newElement.href.indexOf(
                    "https://fonts.googleapis.com/css?family=Roboto"
                ) === 0
            ) {
                return;
            }

            insertBefore.call(head, newElement, referenceElement);
        };
        this.staticMapConfig = {
            longitute: this.lng,
            latitude: this.lat,
            markerColor: "red",
            zoom: this.zoom,
            size: "688x300",
            sizeMobile: "248x300",
        };
    }

    get isActivePlaces(): boolean
    {
        return this.venueService.venueData && this.venueService.venueData.data.attributes.source === 'active_places';
    }

    get hasValidTransport(): boolean
    {
        return this.venueService.venueData
                && this.venueService.venueData.data.attributes.nearest_tube
                && this.venueService.venueData.data.attributes.nearest_tube !== 'unknown';
    }
}
